// extracted by mini-css-extract-plugin
export default {"tab":"TabsContainer_tab__c4ZN7"};